import React, { Component } from 'react';
import { connect } from 'react-redux';
import FileSaver from 'file-saver';

import PdfDataUriViewer from '../documentViewers/pdf/PdfDataUriViewer';
import XmlDataViewer from '../documentViewers/xml/XmlDataViewer';
import FixedFormatDataUriViewer from '../documentViewers/fixedformat/FixedFormatDataUriViewer';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import StaticApplicationMessage from '../inAppMessages/StaticApplicationMessage';

import Logger, {LOG_LEVELS} from '../../utils/logger';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';
const log = new Logger('CLOSED_FILING_PREVIEW', LOG_LEVELS.DEBUG);

let fileExtension;

class ClosedReturnsFilingPreview extends Component {
    onDownloadClick()
    {
        FileSaver.saveAs(this.props.documentData, this.props.fileName + fileExtension);
    }

    render() {
        log.debug('render(): ', this.props,this.props.documentData !== null,this.props.documentData !== undefined);
        const isDownloadableType = this.props.documentType === 'application/pdf' || this.props.documentType === 'application/zip';
        return (
            <fieldset>
                { isDownloadableType ?
                <div >
                    <button className="primary mt10 mb10" onClick={this.onDownloadClick.bind(this)}><LanguageStringResolver string='returnsHistory_DownloadReturn'/></button>
                </div> : <div></div>
                }
                <div className="clear"></div>
                <div className={withFullStoryExclude()}>
                { this.props.documentType ?
                    (() => {
                        switch (this.props.documentType) {
                            case 'PDF':
                            case 'application/pdf':
                                var data =(this.props.documentData !== undefined ? URL.createObjectURL(this.props.documentData) : undefined);
                                fileExtension = '.pdf';
                                return (<PdfDataUriViewer dataUri={data} />);
                            case 'XML':
                            case 'text/xml':
                            case 'application/xml':
                                fileExtension = '.xml';
                                return (this.props.documentData !== undefined || this.props.documentData !== null ?
                                    (<XmlDataViewer xml={this.props.documentData} filename={this.props.fileName + '.xml'}/>) :
                                    <div></div>);
                            case 'FixedFormat':
                            case 'text/plain':
                                fileExtension = '.txt';
                                return (this.props.documentData !== undefined ?
                                    (<FixedFormatDataUriViewer data={this.props.documentData} filename={this.props.fileName + '.txt'}/>) :
                                    <div></div>);
                            case 'text/csv':
                            case 'application/csv':
                                fileExtension = '.csv';
                                return (<FixedFormatDataUriViewer data={this.props.documentData} filename={this.props.fileName + '.csv'}/>);
                            case 'ZIP':
                            case 'application/zip':
                                fileExtension = '.zip';
                                return (
                                    <StaticApplicationMessage
                                        messageType="applicationInfo"
                                        string="filingPreview_zipNotAvailable"
                                        languages={this.props.languages}
                                        nodismiss
                                    />
                                );
                            default:
                                return (<div><LanguageStringResolver string='filingPreviewUnknownType'/>: {this.props.documentType}</div>)
                        }
                    })() : <div></div>
                }
                </div>

            </fieldset>
        );
    }

}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        languages: state.languages
    };
}




// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(ClosedReturnsFilingPreview);